<template>
  <div class="splashScreen">
<!--    <div class="waivLogo">
      <img class="waivLogo1" src="/static/img/WAIVLogo1.svg" alt="">
      <img class="waivLogo2" src="/static/img/WAIVLogo2.svg" alt="">
      <img class="waivLogo3" src="/static/img/WAIVLogo2.svg" alt="">
      <img class="waivLogo4" src="/static/img/WAIVLogo2.svg" alt="">
    </div>-->
    <img class="kovoLogo" src="/static/img/KovoLogoWhite.svg" alt="">
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
  </div>
</template>

<script>
import APIService from "@/servicehandlers/APIService";
import MessageModal from "@/components/MessageModal.vue";
import { useThemeStore } from '@/stores/themeStore';
import { useLoginStore } from '@/stores/loginStore';

const apiService = new APIService()
export default {
  name: 'SplashScreen',
  components: {MessageModal},
  data() {
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
      connected: false,
    }
  },
  mounted() {
    this.checkConnection()
  },
  setup() {
    const themeStore = useThemeStore();
    const loginStore = useLoginStore();
    return { themeStore, loginStore };
  },
  methods: {
    async checkConnection() {
      await this.pingServer()
      if (this.connected) {
        // Apply user's saved theme after successful server connection
        this.applyUserTheme();
        this.goToLogin()
      } else {
        setTimeout(() => this.checkConnection(), 3000)
      }
    },
    applyUserTheme() {
      // Get the user's selected theme from login store
      const selectedTheme = this.loginStore.getSelectedTheme;
      // Load and apply the theme
      this.themeStore.loadThemeFromLoginStore(selectedTheme);
    },
    pingServer(){
      return apiService.ping(this.$router, this.$store)
          .then(response => {
            console.log(JSON.stringify(response, null, 2))
            if (response === 'Pong'){
              this.connected = true
            } else {
              throw new Error(`Unexpected response: ${response}`);
            }
          })
          .catch(e => {
            console.error(JSON.stringify(e, null, 2))
            this.appMessage.text = 'Error connecting to server: ' + e
            this.appMessage.type = 'error'
            this.$refs.messageModal.open()
          })
    },
    goToLogin(){
      setTimeout(() => {
        if (this.$store.loggedIn) {
          this.$router.push({
            name: 'dashboard'
          })
        } else if (this.$store.pastLogging) {
          this.$router.push({
            name: 'login'
          })
        } else {
          this.$router.push({
            name: 'welcome'
          })
        }
      }, 3500)
    },
  },
}
</script>

<style scoped>
.kovoLogo{
  animation: fade 4s ease-in-out infinite;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  50%{
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
/*.waivLogo{
  height: 60px;
  width: 95px;
  display: flex;
  animation: fade 4s ease-in-out infinite;
}

@keyframes fade {
  0%{
    opacity: 0;
  }
  25%{
    opacity: 1;
  }
  75%{
    opacity: 1;
  }
  100%{
    opacity: 0;
  }
}

.waivLogo2{
  width: 20px;
  animation: rotate2 4s ease-in-out infinite;
  transform-origin: left bottom;
  opacity: 0;
}

@keyframes rotate2 {
  0%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  25%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  28%{
    opacity: 1;
  }
  31%{
    transform: rotate(0deg);
    opacity: 1;
  }
  100%{
    transform: rotate(0deg);
    opacity: 1;
  }
}

.waivLogo3{
  width: 20px;
  transform: scaleY(-1) translate(0, 100%);
  animation: rotate3 4s ease-in-out infinite;
  transform-origin: left bottom;
  opacity: 0;
}

@keyframes rotate3 {
  0%{
    transform: scaleY(-1) translate(0, 100%) rotate(-30deg);
    opacity: 0;
  }
  31%{
    transform: scaleY(-1) translate(0, 100%) rotate(-30deg);
    opacity: 0;
  }
  34%{
    opacity: 1;
  }
  37%{
    transform: scaleY(-1) translate(0, 100%) rotate(0deg);
    opacity: 1;
  }
  100%{
    transform: scaleY(-1) translate(0, 100%) rotate(0deg);
    opacity: 1;
  }
}

.waivLogo4{
  width: 20px;
  animation: rotate4 4s ease-in-out infinite;
  transform-origin: left bottom;
  opacity: 0;
}

@keyframes rotate4 {
  0%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  37%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  40%{
    opacity: 1;
  }
  43%{
    transform: rotate(0deg);
    opacity: 1;
  }
  100%{
    transform: rotate(0deg);
    opacity: 1;
  }
}*/

</style>
